// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__1ST0F","modal":"Modal_modal__27AV4","slide-down":"Modal_slide-down__3yXo9"};